import { TemplateId } from '@types';
import WUserInfo from '../WUserInfo';
import WButtonsREA from './WButtonsREA';
import WCategoryBtnREA from './WCategoryBtnREA';
import WCopyrightREA from './WCopyrightREA';

function TRealEstateA() {
  return (
    <>
      <WUserInfo templateId={TemplateId.realEstateA} />
      <WButtonsREA />
      <WCopyrightREA />
      <WCategoryBtnREA />
    </>
  );
}

export default TRealEstateA;
